module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_construction-68573fd80c21de4fa5313301a79362f6.png";